import React from 'react';
import SkillsListElement from './SkillsListElement';
import * as styles from './SkillsList.module.scss';
var SkillsList = function SkillsList(_ref) { var skills = _ref.skills; return /*#__PURE__*/ React.createElement("ul", { className: styles.skillsList }, skills.map(function (skill) { return /*#__PURE__*/ React.createElement(SkillsListElement, { skill: skill, key: skill.name }); })); };
export default SkillsList;
